import { useLocationSearch } from './useLocationSearch';
import { useLocationCountDisplay } from './useLocationCountDisplay';

/**
 * Custom hook that orchestrates location search result counting.
 * Composes:
 * - useLocationSearch: geo-zip fetch + search params management
 * - useLocationCountDisplay: label formatting, visibility, and parent notification
 */
export const useSearchResultCount = ({
	isApiReady,
	sessionToken,
	resetSession,
	selectedPlaceId,
	onLocationStatusChange
}) => {
	const { locationCount, geoError, locationError, isLoading } =
		useLocationSearch({
			isApiReady,
			sessionToken,
			resetSession,
			selectedPlaceId
		});

	const { locationCountString, isHidden, locationLabel } =
		useLocationCountDisplay({
			locationCount,
			error: locationError,
			isLoading,
			onLocationStatusChange
		});

	return {
		locationCountString,
		isHidden,
		locationLabel,
		error: geoError || locationError
	};
};
